import React from "react";


import {
  Card,
  CardBody,
  Grid,
  GridItem,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";


const NewsPageSkeleton = () => {
  return (
    <Grid hasGutter>
      {Array.from({ length: 8 }).map((_, index) => (
        <GridItem
          key={index}
          span={12}
          md={6}
          xl={3}
        >
          <Card isFullHeight>
            <Skeleton
              height="200px"
              screenreaderText="Ładowanie aktualności"
            />

            <CardBody>
              <Stack hasGutter>
                <StackItem>
                  <Skeleton width="35%" />
                </StackItem>

                <StackItem>
                  <Skeleton width="90%" />
                  <Skeleton width="75%" />
                </StackItem>

                <StackItem>
                  <Skeleton />
                  <Skeleton width="95%" />
                  <Skeleton width="70%" />
                </StackItem>
              </Stack>
            </CardBody>
          </Card>
        </GridItem>
      ))}
    </Grid>
  );
};


export default NewsPageSkeleton;